<aside [ngClass]="{'w-20': isSlimMode, 'w-[250px]': !isSlimMode}"
  class="block bg-black dark:bg-dark-sidebar no-print shadow-sidebar transition-all duration-300"
  style="height: calc(100vh - 100px);">
  <div class="flex-1 overflow-auto p-4 flex flex-col justify-between h-full">


    <div class="mb-6">
      <div
        [ngClass]="{'flex-col p-2 rounded-lg bg-gradient-to-br from-gray-800 to-gray-900 border border-gray-600': !isSlimMode, 'justify-center items-center': isSlimMode}"
        class="flex w-full">
        <div class="flex items-center space-x-2 mb-2">

          <div class="relative">
            <div class="animate-pulse bg-gray-600 dark:bg-gray-500 w-10 h-10 rounded-full"></div>
          </div>

          <div *ngIf="!isSlimMode" class="flex flex-col flex-1 min-w-0">
            <div class="animate-pulse bg-gray-600 dark:bg-gray-500 w-20 h-3 rounded mb-1"></div>
            <div class="animate-pulse bg-gray-600 dark:bg-gray-500 w-24 h-2 rounded"></div>
          </div>
        </div>

        <div *ngIf="!isSlimMode" class="flex items-center justify-between pt-1 border-t border-gray-700">
          <div class="flex items-center space-x-1">
            <div class="w-1 h-1 bg-gray-500 rounded-full"></div>
            <div class="animate-pulse bg-gray-600 dark:bg-gray-500 w-12 h-2 rounded"></div>
          </div>
          <div class="animate-pulse bg-gray-600 dark:bg-gray-500 w-16 h-2 rounded"></div>
        </div>
      </div>
    </div>


    <nav class="flex flex-col text-lg w-full h-full justify-between my-6">
      <div class="space-y-2">

        <div class="mb-2">
          <div class="animate-pulse bg-gray-600 dark:bg-gray-500 w-16 h-4 rounded mb-1"></div>
          <div class="animate-pulse bg-gray-600 dark:bg-gray-500 w-full h-px"></div>
        </div>


        <div class="space-y-2">

          <div class="flex items-center space-x-2 p-2 rounded-lg">
            <div class="animate-pulse bg-gray-600 dark:bg-gray-500 w-5 h-5 rounded"></div>
            <div *ngIf="!isSlimMode" class="animate-pulse bg-gray-600 dark:bg-gray-500 w-12 h-4 rounded">
            </div>
          </div>


          <div class="flex items-center space-x-2 p-2 rounded-lg">
            <div class="animate-pulse bg-gray-600 dark:bg-gray-500 w-5 h-5 rounded"></div>
            <div *ngIf="!isSlimMode" class="animate-pulse bg-gray-600 dark:bg-gray-500 w-16 h-4 rounded">
            </div>
          </div>


          <div class="flex items-center space-x-2 p-2 rounded-lg">
            <div class="animate-pulse bg-gray-600 dark:bg-gray-500 w-6 h-6 rounded"></div>
            <div *ngIf="!isSlimMode" class="animate-pulse bg-gray-600 dark:bg-gray-500 w-20 h-4 rounded">
            </div>
          </div>


          <div *ngFor="let item of skeletonNavItems" class="space-y-4 w-full text-center items-center mb-2">
            <div class="flex items-center space-x-2 p-2 rounded-lg">
              <div class="animate-pulse bg-gray-600 dark:bg-gray-500 w-5 h-5 rounded"></div>
              <div *ngIf="!isSlimMode" class="animate-pulse bg-gray-600 dark:bg-gray-500 w-20 h-4 rounded"></div>
            </div>
          </div>
        </div>
      </div>


      <div class="space-y-2">

        <div class="mb-2">
          <div class="animate-pulse bg-gray-600 dark:bg-gray-500 w-16 h-4 rounded mb-1"></div>
          <div class="animate-pulse bg-gray-600 dark:bg-gray-500 w-full h-px"></div>
        </div>


        <div class="space-y-2">

          <div class="flex items-center space-x-2 p-2 rounded-lg">
            <div class="animate-pulse bg-gray-600 dark:bg-gray-500 w-5 h-5 rounded"></div>
            <div *ngIf="!isSlimMode" class="flex flex-col">
              <div class="animate-pulse bg-gray-600 dark:bg-gray-500 w-24 h-3 rounded mb-1"></div>
              <div class="animate-pulse bg-gray-600 dark:bg-gray-500 w-20 h-2 rounded"></div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</aside>
